import { Injectable, TemplateRef, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BaslikPortalService {
  readonly sagTarafTemplate = signal<TemplateRef<any> | null>(null);
}
